export const CREATE_TICKET_URL = 'https://b2b.verizonwireless.com/ticketing/amsecure/login/wbts.go#/problemCategory';
export const MY_BIZ_URL = 'https://mb.verizonwireless.com/mbt/secure/index?appName=esm';
export const THINGSPACE_URL = 'https://thingspace.verizonwireless.com/Portal/manage/dashboard';
export const EDGE_DEVELOPER_URL = 'https://www.verizon.com/business/5g-edge-portal';
export const FEEDBACK_FORM_URL =
    'https://docs.google.com/forms/d/e/1FAIpQLSdZICmwXGB6IYXwpJ5cv_6pPiGnDAS1nlsKa-81PVMJhXSRfw/viewform?usp=pp_url&entry.1845893827=';
export const OSND_PLAYLIST_ID = 'PLIaT08rwxxKneBwaWNdxf6sbfN6_oauia';
export const OSND_VIDEO_URL = `https://www.youtube-nocookie.com/embed?listType=playlist&list=${OSND_PLAYLIST_ID}&enablejsapi=1`;
export const ALERT_TYPES = {
    MAINTENANCE: 'Maintenance',
    OTHER: 'Other'
};

export const SOLUTION_TYPE = {
    EPG: 'EPG',
    EP5G: 'EP5G',
    IBC: 'IBC',
    NDAC: 'NDAC',
    NDAC_NHN: 'NDAC_NHN',
    NHN_PWN: 'NHN_PWN',
    NOKIA_NHN_PWN: 'NOKIA_NHN_PWN',
    UNKNOWN: 'UNKNOWN'
};

export const SIMS_PAGE_URL_MAPPING = {
    sims: '/sims',
    esims: '/sims/esims',
    backup: '/sims/backup',
    directorySync: '/sims/directory-sync',
    audit: '/sims/audit',
    restore: '/sims/restore'
};

export const TSM_TOKEN = 'TSM-TOKEN';
export const ALL_LOCATION_BANNER = 'all_location_banner';
export const LOCAL_STORAGE_KEY = 'osnd_filters';

export const FILTER_KEYS = {
    DEVICES: 'devices',
    AUDIT_LOGS: 'audit_logs',
    NETWORK_NAVIGATOR: {
        INVENTORIES: 'network_navigator_inventories',
        TREE_STATE: 'tree_state',
        SELECTED_NODE: 'selected_node',
        FLOOR_PLAN: 'floor_plan',
        CELL_VIEW: {
            SELECTED_CELLS: 'cell_view_selected_cells',
            SELECTED_BASEBANDS: 'cell_view_selected_basebands',
            SELECTED_IRUS: 'cell_view_selected_irus',
            EXPANDED_NODES: 'cell_view_expanded_nodes',
            SELECTED_NODE_DETAILS: 'cell_view_selected_node_details'
        }
    },
    PERFORMANCE: {
        OVERVIEW: 'performance_overview',
        CORE: 'performance_core',
        COREv2: 'performance_core_v2',
        RADIO: 'performance_radio',
        RADIOv2: 'performance_radio_v2'
    },

    PERFORMANCE_EXFO: {
        OVERVIEW: 'performance_exfo_overview',
        CORE: 'performance_exfo_core',
        RADIO: 'performance_exfo_radio'
    },
    PERFORMANCE_OSND: {
        OUTPOST: 'performance_osnd_outpost',
        EC2_AWS: 'performance_osnd_ec2',
        S3: 'performance_osnd_s3',
        EBS: 'performance_osnd_ebs'
    },
    PERFORMANCE_USAGE: 'performance_usage',
    ROLES: 'roles_page',
    P_SIM: {
        MANAGE: 'p_sim_manage',
        AUDIT: 'p_sim_audit',
        BACKUP: 'p_sim_backup',
        RESTORE: 'p_sim_restore',
        DIR_SYNC: 'p_sim_dir_sync',
        CURRENT_TAB: 'p_sim_current_tab'
    },
    E_SIM: {
        MANAGE: 'e_sim_manage',
        AUDIT: 'e_sim_audit',
        BACKUP: 'e_sim_backup',
        RESTORE: 'e_sim_restore',
        DIR_SYNC: 'e_sim_dir_sync',
        CURRENT_TAB: 'e_sim_current_tab'
    },
    TICKETING: {
        MAIN: 'ticketing_main',
        RESTORATION_TIME: 'ticketing_restoration_time',
        RESPONSE_NOTIFICATION_TIME: 'ticketing_res_notif_time',
        AVAILABILITY: 'ticketing_availability'
    },
    USERS: 'users',
    ALERTS_RULES: 'alerts_rules',
    ALERTS_LIST: 'alerts_list',
};

export const MANUFACTURERS = {
    ERICSSON: 'Ericsson',
    NOKIA: 'Nokia',
    CORNING: 'SpiderCloud Wireless'
};
